import { useState } from "react";
import { qualificationsData } from "./data";
import "./qualifications.css";

export const Qualifications = () => {
  let [qualtoggle, setQualtoggle] = useState(2);

  return (
    <section className="qualifications section" id="Portfolio">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personel journey</span>

      <div className="qualifications_container container">
        <div className="qualifications_tap">
          {/* <div
            className="qualifications_button button--flex"
            onClick={() => setQualtoggle(1)}
          >
            <i className="uil uil-graduation-cap"></i>Education
          </div> */}

          <div
            className="qualifications_button button--flex"
            onClick={() => setQualtoggle(2)}
          >
            <i className="uil uil-bag-alt"></i>Experience
          </div>
        </div>

        <div className="qualifications_sections">
          {/* content  Education*/}
          {/* <div className={ qualtoggle === 1 ? "qualifications_content_active" : "qualifications_content" }>
            {qualificationsData.education.map((item, index) => (
              <div className="qualifications_data" key={index}>
                {/* إذا كان العنصر فرديًا *
                {index % 2 === 0 ? (
                  <>
                    <div>
                      <h3 className="qualifications_title">{item.title}</h3>
                      <span className="qualifications_subtitle">
                        {item.subtitle}
                      </span>
                      <div className="qualifications_calendar">
                        <i className="uil uil-calendar-alt"></i> {item.calendar}
                      </div>
                    </div>
                    <div>
                      <span className="qualifications_rouned"></span>
                      <span className="qualifications_line"></span>
                    </div>
                    <div></div>
                  </>
                ) : (
                  <>
                    <div></div>
                    <div>
                      <span className="qualifications_rouned"></span>
                      <span className="qualifications_line"></span>
                    </div>
                    <div>
                      <h3 className="qualifications_title">{item.title}</h3>
                      <span className="qualifications_subtitle">
                        {item.subtitle}
                      </span>
                      <div className="qualifications_calendar">
                        <i className="uil uil-calendar-alt"></i> {item.calendar}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div> */}

          {/* content  Experience*/}
          <div className={ qualtoggle === 2 ? "qualifications_content_active" : "qualifications_content" }>
            {qualificationsData.experience.map((item, index) => (
              <div className="qualifications_data" key={index}>
                {/* إذا كان العنصر فرديًا */}
                {index % 2 === 0 ? (
                  <>
                    <div>
                      <h3 className="qualifications_title">{item.title}</h3>
                      <span className="qualifications_subtitle">
                        {item.subtitle}
                      </span>
                      <div className="qualifications_calendar">
                        <i className="uil uil-calendar-alt"></i> {item.calendar}
                      </div>
                    </div>
                    <div>
                      <span className="qualifications_rouned"></span>
                      <span className="qualifications_line"></span>
                    </div>
                    <div></div>
                  </>
                ) : (
                  <>
                    <div></div>
                    <div>
                      <span className="qualifications_rouned"></span>
                      <span className="qualifications_line"></span>
                    </div>
                    <div>
                      <h3 className="qualifications_title">{item.title}</h3>
                      <span className="qualifications_subtitle">
                        {item.subtitle}
                      </span>
                      <div className="qualifications_calendar">
                        <i className="uil uil-calendar-alt"></i> {item.calendar}
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
        
      </div>
    </section>
  );
};
